import WithDirection from '@app/settings/withDirection';
import { Timeline } from 'antd';
import AntTimeline from './styles/timeline.style';

const WDTimelineItem = AntTimeline(Timeline.Item);
const Timelines = AntTimeline(Timeline);

export const IsoTimeline = WithDirection(Timelines);
export const IsoTimelineItem = WithDirection(WDTimelineItem);
